var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgInbox2Line = function SvgInbox2Line(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 25 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M6.518 5.837a.75.75 0 0 1 .732-.587h10.5a.75.75 0 0 1 .732.587l1.5 6.75a.8.8 0 0 1 .018.163V18a.75.75 0 0 1-.75.75H5.75A.75.75 0 0 1 5 18v-5.25a.8.8 0 0 1 .018-.163zm1.334.913L6.685 12h3.565a2.25 2.25 0 1 0 4.5 0h3.565l-1.167-5.25zm8.086 6.75a3.751 3.751 0 0 1-6.876 0H6.5v3.75h12V13.5z"
  })));
};
export default SvgInbox2Line;